import { useEffect, useState } from 'react'
import { getQboListsShared } from '@/services/qbo'

export function useQboVendorDisplayNameMap(): Record<string, string> {
  const [map, setMap] = useState<Record<string, string>>({})
  useEffect(() => {
    let cancelled = false
    void getQboListsShared().then(({ vendors }) => {
      if (cancelled) return
      setMap(Object.fromEntries(vendors.map((vendor) => [vendor.id, vendor.display_name])))
    })
    return () => {
      cancelled = true
    }
  }, [])
  return map
}

export function formatQboVendorLabel(
  qboVendorId: string,
  nameMap: Record<string, string>,
): string {
  const displayName = nameMap[qboVendorId]?.trim()
  return displayName || qboVendorId
}

export function qboVendorFilterOptions(
  vendorIds: string[],
  nameMap: Record<string, string>,
): Array<{ value: string; label: string }> {
  return [...new Set(vendorIds.filter(Boolean))]
    .sort((a, b) => formatQboVendorLabel(a, nameMap).localeCompare(formatQboVendorLabel(b, nameMap)))
    .map((value) => ({ value, label: formatQboVendorLabel(value, nameMap) }))
}
